import React, { useState } from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/it";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./custom_calendar.scss";

moment.locale("it");
const localizer = momentLocalizer(moment);

const messages = {
  allDay: "Tutto il giorno",
  previous: "Precedente",
  next: "Successivo",
  today: "Oggi",
  month: "Mese",
  week: "Settimana",
  day: "Giorno",
  agenda: "Agenda",
  date: "Data",
  time: "Ora",
  event: "Evento",
  noEventsInRange: "Non ci sono eventi in questo intervallo.",
  showMore: (total) => `+ Vedi altri (${total})`,
};

const CustomCalendar = ({
  events,
  onSelectSlot,
  onSelectEvent,
  minDate,
  maxDate,
  isLoading,
  eventCursor = 'pointer',
  slotCursor = 'pointer',
  customEventPropGetter,
  ...props
}) => {

  const [currentView, setCurrentView] = useState('agenda'); // agenda come default
  const [currentDate, setCurrentDate] = useState(new Date()); // NEW


  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  const handleNavigate = (newDate, view, action) => {
    setCurrentDate(newDate);
  };

  const enhancedEvents = events.map(event => ({
    ...event,
    isAgenda: currentView === 'agenda'
  }));
  
  const handleSelectSlot = (slotInfo) => {
    if (!isLoading) {
      const slotDate = new Date(slotInfo.start);
      if ((!minDate || slotDate >= minDate) && (!maxDate || slotDate <= maxDate)) {
        onSelectSlot(slotInfo);
      }
    }
  };

  const handleSelectEvent = (event) => {
    if (!isLoading) {
      onSelectEvent(event);
    }
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    if (event?.isAgenda) {
      return { style: {} };
    }

    let defaultStyle = {
      backgroundColor: isLoading ? '#ccc' : event.color,
      borderRadius: '5px',
      opacity: isLoading ? 0.5 : 0.8,
      color: isLoading ? '#666' : 'white',
      border: '0px',
      cursor: isLoading ? 'not-allowed' : eventCursor
    };
  
    if (customEventPropGetter) {
      const customStyle = customEventPropGetter(event, start, end, isSelected);
      return {
        ...customStyle,
        style: {
          ...defaultStyle,
          ...customStyle.style
        }
      };
    }
  
    return { style: defaultStyle };
  };

  // const eventStyleGetter = (event, start, end, isSelected) => {
  //   let defaultStyle = {
  //     backgroundColor: isLoading ? '#ccc' : event.color,
  //     borderRadius: '5px',
  //     opacity: isLoading ? 0.5 : 0.8,
  //     color: isLoading ? '#666' : 'white',
  //     border: '0px',
  //     display: 'block',
  //     cursor: isLoading ? 'not-allowed' : eventCursor
  //   };

  //   if (customEventPropGetter) {
  //     const customStyle = customEventPropGetter(event, start, end, isSelected);
  //     return {
  //       ...customStyle,
  //       style: {
  //         ...defaultStyle,
  //         ...customStyle.style
  //       }
  //     };
  //   }

  //   return { style: defaultStyle };
  // };

  const CustomEvent = ({ event }) => {
    return (
      <span style={{ cursor: 'pointer' }}>{event.title}</span>
    );
  };

  const CustomAgendaTime = ({ event }) => {
    return (
      <div
        style={{ cursor: 'pointer', color: 'inherit' }}
        onClick={() => handleSelectEvent(event)}
      >
        {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
      </div>
    );
  };

  const CustomToolbar = ({ label, onView, view, views, onNavigate, date }) => {
    const getTitle = () => {
      if (view === 'month') {
        return `${moment(date).format('MMMM YYYY')} - Calendario Esami`;
      }
      return 'Calendario Esami';
    };

    return (
      <div className="rbc-toolbar d-flex justify-content-between align-items-center">
        {/* Se NON sei in agenda, mostro i bottoni a sinistra */}
        {view !== 'agenda' && (
          <div className="d-flex align-items-center">
            <button onClick={() => onNavigate('TODAY')} className="btn btn-outline-primary btn-sm me-2">Oggi</button>
            <button onClick={() => onNavigate('PREV')} className="btn btn-outline-primary btn-sm me-2">Precedente</button>
            <button onClick={() => onNavigate('NEXT')} className="btn btn-outline-primary btn-sm">Successivo</button>
          </div>
        )}
  
        {/* Titolo centrale */}
        <div className="text-center flex-grow-1">
          <h4 className="text-primary mb-0">{getTitle()}</h4>
        </div>
  
        {/* Pulsanti a destra per cambiare vista */}
        <div className="d-flex align-items-center">
          {views.includes('month') && (
            <button 
              onClick={() => onView('month')} 
              className={`btn btn-sm ${view === 'month' ? 'btn-primary' : 'btn-outline-primary'} me-2`}
            >
              Inserisci
            </button>
          )}
          {views.includes('agenda') && (
            <button 
              onClick={() => onView('agenda')} 
              className={`btn btn-sm ${view === 'agenda' ? 'btn-primary' : 'btn-outline-primary'}`}
            >
              Visualizza
            </button>
          )}
        </div>
      </div>
    );
  };
  

  const dayPropGetter = (date) => {
    if (isLoading || (minDate && date < minDate) || (maxDate && date > maxDate)) {
      return {
        className: "disabled-day",
        style: {
          cursor: "not-allowed",
          backgroundColor: "#f0f0f0",
          color: "#999",
        },
      };
    } else {
      return {
        className: "selectable-day",
        style: {
          cursor: slotCursor,
        },
      };
    }
  };

  return (
    <Calendar
      localizer={localizer}
      events={enhancedEvents}
      startAccessor="start"
      endAccessor="end"
      view={currentView}
      onView={handleViewChange}
      style={{ height: "calc(100% - 100px)" }}
      selectable={!isLoading}
      onNavigate={handleNavigate}
      onSelectSlot={handleSelectSlot}
      onSelectEvent={handleSelectEvent}
      min={minDate}
      max={maxDate}
      messages={messages}
      views={props.availableViews || ["agenda"]}
      defaultView={props.availableViews?.[0] || "agenda"}
      formats={{
        monthHeaderFormat: "MMMM YYYY",
        weekdayFormat: "dddd",
        dayHeaderFormat: "dddd D MMMM",
        dayRangeHeaderFormat: ({ start, end }) =>
          `${moment(start).format("D MMMM")} - ${moment(end).format("D MMMM YYYY")}`,
        agendaDateFormat: (date) => moment(date).format("ddd DD MMMM YYYY"),
      }}
      //defaultDate={minDate || new Date()}
      date={currentDate}
      defaultDate={currentDate}
      dayPropGetter={dayPropGetter}
      components={{
        event: CustomEvent,
        agenda: {
          time: CustomAgendaTime,
          event: CustomEvent
        },
        toolbar: (toolbarProps) => {
          const ToolbarComponent = props.customToolbar || CustomToolbar;
          return <ToolbarComponent {...toolbarProps} />;
        },
      }}
      onShowMore={(events, date) => {
        setCurrentView('agenda');
        setCurrentDate(date);
      }}
      eventPropGetter={eventStyleGetter}
      {...props}
    />
    // <Calendar
    //   localizer={localizer}
    //   events={enhancedEvents}
    //   startAccessor="start"
    //   endAccessor="end"
    //   view={currentView}
    //   onView={handleViewChange}
    //   style={{ height: "calc(100% - 100px)" }}
    //   selectable={!isLoading}
    //   onSelectSlot={handleSelectSlot}
    //   onSelectEvent={handleSelectEvent}
    //   min={minDate}
    //   max={maxDate}
    //   messages={messages}
    //   defaultView="agenda"
    //   views={["month","agenda"]}
    //   formats={{
    //     monthHeaderFormat: "MMMM YYYY",
    //     weekdayFormat: "dddd",
    //     dayHeaderFormat: "dddd D MMMM",
    //     dayRangeHeaderFormat: ({ start, end }) =>
    //       `${moment(start).format("D MMMM")} - ${moment(end).format(
    //         "D MMMM YYYY"
    //       )}`,
    //     agendaDateFormat: (date) => moment(date).format("ddd DD MMMM YYYY"), // <--- questa è la riga nuova
    //   }}
    //   defaultDate={minDate || new Date()}
    //   dayPropGetter={dayPropGetter}
    //   components={{
    //     event: CustomEvent,
    //     agenda: {
    //       time: CustomAgendaTime,
    //       event: CustomEvent
    //     },
    //     toolbar: CustomToolbar,
    //   }}
    //   eventPropGetter={eventStyleGetter}
    //   {...props}
    // />
  );
};

export default CustomCalendar;
